/**
 * @generated SignedSource<<641ae4457ccd5e2635a0ea898917695e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TeamPipelineDeleteInput = {
  clientMutationId?: string | null;
  force?: boolean | null;
  id: string;
};
export type PipelinesTeamDeleteMutation$variables = {
  input: TeamPipelineDeleteInput;
};
export type PipelinesTeamDeleteMutation$data = {
  readonly teamPipelineDelete: {
    readonly deletedTeamPipelineID: string;
    readonly team: {
      readonly id: string;
      readonly pipelines: {
        readonly count: number;
      } | null;
    } | null;
  } | null;
};
export type PipelinesTeamDeleteMutation = {
  response: PipelinesTeamDeleteMutation$data;
  variables: PipelinesTeamDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TeamPipelineDeletePayload",
    "kind": "LinkedField",
    "name": "teamPipelineDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedTeamPipelineID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamPipelineConnection",
            "kind": "LinkedField",
            "name": "pipelines",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelinesTeamDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PipelinesTeamDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f6c0af7e9e9fe4a8e61b074ce63d1114",
    "id": null,
    "metadata": {},
    "name": "PipelinesTeamDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PipelinesTeamDeleteMutation(\n  $input: TeamPipelineDeleteInput!\n) {\n  teamPipelineDelete(input: $input) {\n    deletedTeamPipelineID\n    team {\n      id\n      pipelines {\n        count\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b26401233d0aa077d3ea326ee341ccd0";

export default node;
